import { Route } from "react-router-dom";

export const renderRoutes = (routes) =>
  routes.map((route, idx) => {
    // If route has nested children
    if (route.children) {
      return (
        <Route key={idx} element={route.element}>
          {renderRoutes(route.children)}
        </Route>
      );
    }

    // If route is just a normal one
    return <Route key={idx} path={route.path} element={route.element} />;
  });
